import EquipmentsList from "./equipmentsList";

export default EquipmentsList;
